/* eslint-disable import/prefer-default-export */
export const statusTypes = {
  active: { label: 'Ativo' },
  paid: { label: 'Pagamento efetuado' },
  pending: { label: 'Aguardando pagamento' },
  rejected: { label: 'Pagamento rejeitado' },
  canceled: { label: 'Pagamento cancelado' }
}
